import { Controller } from '@hotwired/stimulus';

// Toggles `is-offscreen` on the element when it leaves the viewport, so CSS can
// pause an expensive looping animation (animation-play-state: paused) off-screen.
export default class extends Controller {
  connect() {
    this.__observer = new IntersectionObserver(([entry]) => {
      this.element.classList.toggle('is-offscreen', !entry.isIntersecting);
    });
    this.__observer.observe(this.element);
  }

  disconnect() {
    this.__observer?.disconnect();
  }
}
